import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Text = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g id="text__16">
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 4C1 3.72386 1.22386 3.5 1.5 3.5H14.5C14.7761 3.5 15 3.72386 15 4C15 4.27614 14.7761 4.5 14.5 4.5H1.5C1.22386 4.5 1 4.27614 1 4ZM1 8C1 7.72386 1.22386 7.5 1.5 7.5H14.5C14.7761 7.5 15 7.72386 15 8C15 8.27614 14.7761 8.5 14.5 8.5H1.5C1.22386 8.5 1 8.27614 1 8ZM1.5 11.5C1.22386 11.5 1 11.7239 1 12C1 12.2761 1.22386 12.5 1.5 12.5H9.5C9.77614 12.5 10 12.2761 10 12C10 11.7239 9.77614 11.5 9.5 11.5H1.5Z"
        />
      </g>
    </svg>
  )
})

export default Text
